import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faHeadset, faPiggyBank, faSmileBeam, faBolt, faRocket, faTimesCircle, faTimes, faArrowRight, faCheckCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticBenefitsSection.css';
import deliveryTruck from "../../assets/app/Logistic/delivery-truck.png";
import aiChatbotSupport from "../../assets/app/Logistic/ai-chatbot-support.png";
import { useTranslation } from 'react-i18next';

const LogisticBenefitsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-benefits-section" id="beneficios">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticBenefitsSection:section_tag')}</span>
          <h2>
            {t('LogisticBenefitsSection:title_prefix')}{' '}
            <span className="logistic-text-success">{t('LogisticBenefitsSection:title_strong')}</span>
          </h2>
        </div>
        
        <div className="logistic-benefits-images">
          <div className="logistic-benefit-image">
            <img src={deliveryTruck} alt={t('LogisticBenefitsSection:alt_text_1')} loading="lazy" />
            <div className="logistic-image-overlay">
              <FontAwesomeIcon icon={faTruck} />
              <p>{t('LogisticBenefitsSection:image_overlay_1')}</p>
            </div>
          </div>
          <div className="logistic-benefit-image">
            <img src={aiChatbotSupport} alt={t('LogisticBenefitsSection:alt_text_2')} loading="lazy" />
            <div className="logistic-image-overlay">
              <FontAwesomeIcon icon={faHeadset} />
              <p>{t('LogisticBenefitsSection:image_overlay_2')}</p>
            </div>
          </div>
        </div>

        <div className="logistic-metrics-grid">
          <div className="logistic-metric-card">
            <div className="logistic-metric-icon blue">
              <FontAwesomeIcon icon={faPiggyBank} />
            </div>
            <div className="logistic-metric-value">
              <span className="logistic-counter">{t('LogisticBenefitsSection:metric1_value')}</span>%
            </div>
            <h3>{t('LogisticBenefitsSection:metric1_title')}</h3>
            <p>{t('LogisticBenefitsSection:metric1_text')}</p>
            <div className="logistic-metric-detail">
              {t('LogisticBenefitsSection:metric1_detail_prefix')}{' '}
              <strong>{t('LogisticBenefitsSection:metric1_detail_strong')}</strong>
              {t('LogisticBenefitsSection:metric1_detail_suffix')}
            </div>
          </div>

          <div className="logistic-metric-card">
            <div className="logistic-metric-icon green">
              <FontAwesomeIcon icon={faSmileBeam} />
            </div>
            <div className="logistic-metric-value">
              <span className="logistic-counter">{t('LogisticBenefitsSection:metric2_value')}</span>%
            </div>
            <h3>{t('LogisticBenefitsSection:metric2_title')}</h3>
            <p>{t('LogisticBenefitsSection:metric2_text')}</p>
            <div className="logistic-metric-detail">
              {t('LogisticBenefitsSection:metric2_detail_prefix')}{' '}
              <strong>{t('LogisticBenefitsSection:metric2_detail_strong')}</strong>
            </div>
          </div>

          <div className="logistic-metric-card">
            <div className="logistic-metric-icon purple">
              <FontAwesomeIcon icon={faBolt} />
            </div>
            <div className="logistic-metric-value">
              <span className="logistic-counter">{t('LogisticBenefitsSection:metric3_value')}</span>%
            </div>
            <h3>{t('LogisticBenefitsSection:metric3_title')}</h3>
            <p>{t('LogisticBenefitsSection:metric3_text')}</p>
            <div className="logistic-metric-detail">
              {t('LogisticBenefitsSection:metric3_detail_prefix')}{' '}
              <strong>{t('LogisticBenefitsSection:metric3_detail_strong')}</strong>
            </div>
          </div>

          <div className="logistic-metric-card">
            <div className="logistic-metric-icon orange">
              <FontAwesomeIcon icon={faRocket} />
            </div>
            <div className="logistic-metric-value">
              <span className="logistic-counter">{t('LogisticBenefitsSection:metric4_value')}</span>x
            </div>
            <h3>{t('LogisticBenefitsSection:metric4_title')}</h3>
            <p>{t('LogisticBenefitsSection:metric4_text')}</p>
            <div className="logistic-metric-detail">
              {t('LogisticBenefitsSection:metric4_detail_prefix')}{' '}
              <strong>{t('LogisticBenefitsSection:metric4_detail_strong')}</strong>
            </div>
          </div>
        </div>

        <div className="logistic-comparison-table">
          <h3>{t('LogisticBenefitsSection:comparison_title')}</h3>
          <div className="logistic-comparison-container">
            <div className="logistic-comparison-column logistic-bad">
              <div className="logistic-comparison-header">
                <FontAwesomeIcon icon={faTimesCircle} />
                <h4>{t('LogisticBenefitsSection:column1_title')}</h4>
              </div>
              <ul>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item1')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item2')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item3')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item4')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item5')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item6')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item7')}</li>
                <li><FontAwesomeIcon icon={faTimes} /> {t('LogisticBenefitsSection:column1_item8')}</li>
              </ul>
            </div>

            <div className="logistic-comparison-divider">
              <div className="logistic-divider-icon">
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
            </div>

            <div className="logistic-comparison-column logistic-good">
              <div className="logistic-comparison-header">
                <FontAwesomeIcon icon={faCheckCircle} />
                <h4>{t('LogisticBenefitsSection:column2_title')}</h4>
              </div>
              <ul>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item1')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item2')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item3')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item4')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item5')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item6')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item7')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticBenefitsSection:column2_item8')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticBenefitsSection;